import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from '../../assests/images/marketing-img.png';
import blogBannerAccessory1 from '../../assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from '../../assests/images/features-accessory-3.png';
import {HOW_IT_WORKS_PAGE, LANDING_MENU}  from 'constants/page.const'
import { useHistory, useLocation } from 'react-router';

const Blog = (props) => {
    
  return (

    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className='container'>
            <div>
              <h1 className="section__title--big">
               {HOW_IT_WORKS_PAGE.title}
              </h1>
              <p className="info-text--big">
              {HOW_IT_WORKS_PAGE.desc}
              </p>
            </div>
            <figure>
              <img src={marketingImg} alt="Blog Banner Image" />
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="Accessory Image"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="Accessory Image"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container" dangerouslySetInnerHTML={HOW_IT_WORKS_PAGE.content}>
            
            </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default Blog;
